/**
 * Generated from KitchenScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function KitchenScreenLayout(this: $KitchenScreenLayout) {
	const durianStep = this.durianStep;
	$(durianStep, 0, durianStep1, {x:1024, y:768});
	$(durianStep, 1, durianStep2, {x:1024, y:768});
	$(durianStep, 2, durianStep3, {x:1024, y:768});
	$(durianStep, 3, durianStep4, {x:1024, y:768});
	$(durianStep, 4, durianStep5, {x:1024, y:768});
	$(durianStep, 5, durianStep6, {x:1024, y:768});
	const pastaStep = this.pastaStep;
	$(pastaStep, 0, pastaStep1, {x:1024, y:768});
	$(pastaStep, 1, pastaStep2, {x:1024, y:768});
	$(pastaStep, 2, pastaStep4, {x:1024, y:768});
	$(pastaStep, 3, pastaStep5, {x:1024, y:768});
	$(pastaStep, 4, pastaStep6, {x:1024, y:768});
	$(pastaStep, 5, pastaStep7, {x:1024, y:768});
	const delightStep = this.delightStep;
	$(delightStep, 0, delightStep1, {x:1024, y:768});
	$(delightStep, 1, delightStep2, {x:1024, y:768});
	$(delightStep, 2, delightStep3, {x:1024, y:768});
	$(delightStep, 3, delightStep4, {x:1024, y:768});
	$(delightStep, 4, delightStep5, {x:1024, y:768});
	$(delightStep, 5, delightStep6, {x:1024, y:768});
	$(delightStep, 6, delightStep7, {x:1024, y:768});
	const coconutStep = this.coconutStep;
	$(coconutStep, 0, coconutStep1, {x:1024, y:768});
	$(coconutStep, 1, coconutStep2, {x:1024, y:768});
	$(coconutStep, 2, coconutStep3, {x:1024, y:768});
	$(coconutStep, 3, coconutStep4, {x:1024, y:768});
	$(coconutStep, 4, coconutStep5, {x:1024, y:768});
	$(this, "main", main, {x:1024, y:768});
	$(this, "pastaStepBase", pastaStepBase, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	$(this, "background", background, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "freezer", freezer, {x:614.1, y:-611.35});
	$(this, "oven", oven, {x:-273.9, y:-266.05});
	$(this, "freezerTimerPosition", timerPoint, {x:616.25, y:-615.2, w:146.00, h: 146.00});
	$(this, "ovenTimerPosition", timerPoint, {x:-264.95, y:-289.4, w:146.00, h: 146.00});
	$(this, "timer", timer, {x:13.6, y:-963.4});
	$(this, "potTimerPosition", timerPoint, {x:-264.3, y:-556.3, w:146.00, h: 146.00});
	$(this, "luna", luna, {x:-728.5, y:884, w:557.00, h: 555.00});
	return this;
}
function background(this: $background) {
	if (this.setLayoutTexture) this.setLayoutTexture("kitchen.jpg", 0.000, 0.000);
	return this;
}
function freezer(this: $freezer) {
	const frames = this.frames;
	$(frames, 0, freezerDoor2, {x:35.85, y:-19.4, w:392.00, h: 394.00});
	$(frames, 1, freezerDoor3, {x:375.85, y:41.4, w:418.00, h: 360.00});
	$(this, "sprite", freezerDoor1, {x:0, y:0, w:455.00, h: 339.00});
	return this;
}
function freezerDoor1(this: $freezerDoor1) {
	if (this.setLayoutTexture) this.setLayoutTexture("freezer-door-1.png", 0.501, 0.501);
	return this;
}
function freezerDoor2(this: $freezerDoor2) {
	if (this.setLayoutTexture) this.setLayoutTexture("freezer-door-2.png", 0.500, 0.500);
	return this;
}
function freezerDoor3(this: $freezerDoor3) {
	if (this.setLayoutTexture) this.setLayoutTexture("freezer-door-3.png", 0.500, 0.500);
	return this;
}
function oven(this: $oven) {
	const frames = this.frames;
	$(frames, 0, ovenDoor2, {x:2.25, y:41.25, w:434.00, h: 180.00});
	$(frames, 1, ovenDoor3, {x:-10.5, y:157.5, w:466.00, h: 120.00});
	$(this, "sprite", ovenDoor1, {x:0, y:0, w:426.00, h: 270.00});
	return this;
}
function ovenDoor1(this: $ovenDoor1) {
	if (this.setLayoutTexture) this.setLayoutTexture("oven-door-1.png", 0.500, 0.500);
	return this;
}
function ovenDoor2(this: $ovenDoor2) {
	if (this.setLayoutTexture) this.setLayoutTexture("oven-door-2.png", 0.500, 0.500);
	return this;
}
function ovenDoor3(this: $ovenDoor3) {
	if (this.setLayoutTexture) this.setLayoutTexture("oven-door-3.png", 0.500, 0.500);
	return this;
}
function timerPoint(this: $timerPoint) {
	if (this.setLayoutTexture) this.setLayoutTexture("freezer-timer-base.png", 0.500, 0.500);
	return this;
}
function timer(this: $timer) {
	$(this, "base", freezerTimerBase, {x:0, y:0, w:146.00, h: 146.00});
	$(this, "circle", freezerTimerFill, {x:0, y:0, w:144.00, h:144.00});
	$(this, "stroke", freezerTimerStroke, {x:0, y:0, w:149.00, h: 148.00});
	return this;
}
function freezerTimerBase(this: $freezerTimerBase) {
	if (this.setLayoutTexture) this.setLayoutTexture("freezer-timer-base.png", 0.500, 0.500);
	return this;
}
function freezerTimerFill(this: $freezerTimerFill) {
	return this;
}
function freezerTimerStroke(this: $freezerTimerStroke) {
	if (this.setLayoutTexture) this.setLayoutTexture("freezer-timer-stroke.png", 0.500, 0.500);
	return this;
}
function luna(this: $luna) {
	if (this.setLayoutTexture) this.setLayoutTexture("luna-prompter.png", 0.500, 1.000);
	return this;
}
export function pastaStepBase(this: $pastaStepBase) {
	$(this, "pastaPot", pastaPot, {x:-266.85, y:-582.3});
	return this;
}
function pastaPot(this: $pastaPot) {
	$(this, "pastaPotBack", pastaPotBack, {x:0, y:0, w:440.00, h: 282.00});
	$(this, "noodles", noodlesOption6, {x:0, y:0, w:261.50, h: 144.00});
	$(this, "pastaPotFront", pastaPotFront, {x:0, y:10, w:440.00, h: 247.00});
	$(this, "bubblesBounds", bubblesBounds, {x:-84.85, y:-98.05, w:177.10, h:4.20});
	return this;
}
function pastaPotBack(this: $pastaPotBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-pot-back.png", 0.500, 0.500);
	return this;
}
function noodlesOption6(this: $noodlesOption6) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-6.png", 0.500, 0.500);
	return this;
}
function pastaPotFront(this: $pastaPotFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-pot-front.png", 0.500, 0.500);
	return this;
}
function bubblesBounds(this: $bubblesBounds) {
	return this;
}
export function durianStep1(this: $durianStep1) {
	$(this, "cuttingBoard", cuttingBoard, {x:-4.5, y:344, w:1481.00, h: 730.00});
	$(this, "durianCut", durianCut, {x:63.15, y:80.8});
	return this;
}
function cuttingBoard(this: $cuttingBoard) {
	if (this.setLayoutTexture) this.setLayoutTexture("cutting-board.png", 0.500, 0.500);
	return this;
}
function durianCut(this: $durianCut) {
	$(this, "sprite", durianWhole, {x:0, y:0, w:802.00, h: 532.00});
	$(this, "durianEmpty", durianEmpty, {x:0, y:15.5, w:802.00, h: 501.00});
	$(this, "durianFruit", durianFruit, {x:-53.2, y:-51.45, w:615.00, h: 286.00});
	$(this, "durianTop", durianTop, {x:-59.8, y:-68.5, w:683.00, h: 395.00});
	return this;
}
function durianWhole(this: $durianWhole) {
	if (this.setLayoutTexture) this.setLayoutTexture("durian-whole.png", 0.500, 0.500);
	return this;
}
function durianEmpty(this: $durianEmpty) {
	if (this.setLayoutTexture) this.setLayoutTexture("durian-empty.png", 0.500, 0.500);
	return this;
}
function durianFruit(this: $durianFruit) {
	if (this.setLayoutTexture) this.setLayoutTexture("durian-fruit.png", 0.500, 0.500);
	return this;
}
function durianTop(this: $durianTop) {
	if (this.setLayoutTexture) this.setLayoutTexture("durian-top.png", 0.500, 0.500);
	return this;
}
export function durianStep2(this: $durianStep2) {
	$(this, "durianOpen", durianOpen, {x:-205.55, y:3.5});
	$(this, "ingredientVanilla", ingredientVanilla, {x:108.3, y:281.1});
	$(this, "ingredientSugar", ingredientSugar, {x:-291.3, y:394.6});
	$(this, "ingredientCream", ingredientCream, {x:-718.2, y:116.35});
	$(this, "bowlMix", bowlMix, {x:531.2, y:143.65});
	$(this, "arrow", arrow, {x:-246.3, y:-249.5, w:288.00, h: 310.00});
	$(this, "arrowEnd", arrow, {x:518.65, y:1.4, w:288.00, h: 310.00});
	return this;
}
function durianOpen(this: $durianOpen) {
	$(this, "durianEmpty", durianEmpty, {x:0, y:15.5, w:802.00, h: 501.00});
	$(this, "durianFruit", durianFruit, {x:-53.2, y:-51.45, w:615.00, h: 286.00});
	return this;
}
function ingredientVanilla(this: $ingredientVanilla) {
	$(this, "sprite", ingredientVanillaSprite, {x:-1.3, y:113.25, w:115.00, h: 297.00});
	$(this, "pouringPoint", pouringPoint, {x:-1.25, y:-34.95, w:20.00, h:20.00});
	return this;
}
function ingredientVanillaSprite(this: $ingredientVanillaSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("ingredient-vanilla.png", 0.500, 0.500);
	return this;
}
function pouringPoint(this: $pouringPoint) {
	return this;
}
function ingredientSugar(this: $ingredientSugar) {
	$(this, "sprite", ingredientSugarSprite, {x:0, y:41.5, w:372.00, h: 185.00});
	$(this, "pouringPoint", pouringPoint, {x:124.15, y:16.65, w:20.00, h:20.00});
	return this;
}
function ingredientSugarSprite(this: $ingredientSugarSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("ingredient-sugar.png", 0.500, 0.500);
	return this;
}
function ingredientCream(this: $ingredientCream) {
	$(this, "sprite", ingredientCreamSprite, {x:-93, y:-24.5, w:185.00, h: 456.00});
	$(this, "pouringPoint", pouringPoint, {x:-0.9, y:-3.15, w:20.00, h:20.00});
	return this;
}
function ingredientCreamSprite(this: $ingredientCreamSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("ingredient-cream.png", 0.000, 0.000);
	return this;
}
function bowlMix(this: $bowlMix) {
	$(this, "bowlBack", bowlBack, {x:0.95, y:-12.85, w:596.00, h: 118.00});
	$(this, "bowlContent", bowlContent, {x:-9.35, y:13.6, w:605.00, h: 147.00});
	$(this, "spoon", spoon, {x:6.7, y:-125.25, w:131.00, h: 577.00});
	$(this, "bowlFront", bowlFront, {x:0, y:0, w:656.00, h: 453.00});
	return this;
}
function bowlBack(this: $bowlBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bowl-back.png", 0.500, 0.500);
	return this;
}
function bowlContent(this: $bowlContent) {
	if (this.setLayoutTexture) this.setLayoutTexture("bowl-content.png", 0.500, 0.500);
	return this;
}
function spoon(this: $spoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("spoon.png", 0.500, 0.500);
	return this;
}
function bowlFront(this: $bowlFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("bowl-front.png", 0.500, 0.500);
	return this;
}
function arrow(this: $arrow) {
	if (this.setLayoutTexture) this.setLayoutTexture("arrow-green.png", 0.510, 0.942);
	return this;
}
export function durianStep3(this: $durianStep3) {
	$(this, "bowlMix", bowlMix, {x:-5.3, y:165.25});
	$(this, "spoon", spoon, {x:-25.4, y:548.2, r:1.6200, w:130.99, h: 576.95});
	$(this, "spoonTop", spoon, {x:2, y:-130.9, w:131.00, h: 577.00});
	return this;
}
export function durianStep4(this: $durianStep4) {
	$(this, "bowlMix", bowlMix, {x:615.2, y:-631.55, sx:0.440, sy:0.440});
	$(this, "bowlCook", bowlIceCream, {x:-17.3, y:145.75});
	return this;
}
function bowlIceCream(this: $bowlIceCream) {
	const iceCream = this.iceCream;
	$(iceCream, 0, iceCream1, {x:10.2, y:-63.55, w:537.00, h: 364.00});
	$(iceCream, 1, iceCream2, {x:10.2, y:-39.05, w:537.00, h: 315.00});
	$(iceCream, 2, iceCream3, {x:-86.1, y:-88.75, w:345.00, h: 195.00});
	const toppingMask = this.toppingMask;
	$(toppingMask, 0, [-257.25,-37.05,-238.65,-59.30,-211.75,-65.40,-209.90,-89.95,-203.60,-119.15,-179.90,-146.75,-143.60,-172.05,-91.55,-185.45,-71.80,-215.45,-35.50,-234.40,11.75,-246.15,59.75,-240.05,93.40,-222.60,123.15,-195.70,161.00,-186.25,198.10,-155.45,217.05,-125.45,218.65,-93.90,248.60,-91.55,273.10,-68.65,280.20,-45.75,271.50,-17.35,261.25,-15.00,251.80,-26.05,159.45,-7.10,43.45,2.40,34.70,9.60,-140.75,6.15,-236.35,-2.25,-257.45,-12.15]);
	$(toppingMask, 1, [-257.25,-37.05,-238.65,-59.30,-211.75,-65.40,-209.90,-89.95,-203.60,-119.15,-179.90,-146.75,-143.60,-172.05,-91.55,-185.45,-55.10,-183.70,-22.05,-171.70,5.20,-148.40,37.75,-179.75,80.75,-195.75,123.15,-195.70,161.00,-186.25,198.10,-155.45,217.05,-125.45,218.65,-93.90,248.60,-91.55,273.10,-68.65,280.20,-45.75,271.50,-17.35,261.25,-15.00,251.80,-26.05,159.45,-7.10,43.45,2.40,34.70,9.60,-140.75,6.15,-236.35,-2.25,-257.45,-12.15]);
	$(toppingMask, 2, [-257.25,-37.05,-238.65,-59.30,-211.75,-65.40,-209.90,-89.95,-203.60,-119.15,-179.90,-146.75,-143.60,-172.05,-91.55,-185.45,-55.10,-183.70,-18.70,-169.40,-1.30,-153.40,8.85,-140.30,20.40,-124.35,24.90,-107.15,26.00,-82.55,54.95,-77.70,70.70,-69.90,82.45,-50.05,86.50,-36.25,85.65,-18.70,75.40,-0.15,67.00,6.10,34.70,9.60,-140.75,6.15,-236.35,-2.25,-257.45,-12.15]);
	const toppings = this.toppings;
	$(toppings, 0, sprinklesColoured, {x:66, y:-167.45, w:634.00, h: 193.00});
	$(toppings, 1, sprinklesChocolate, {x:66, y:-167.45, w:634.00, h: 193.00});
	$(toppings, 2, sprinklesCoconut, {x:66, y:-167.45, w:634.00, h: 193.00});
	$(this, "bowlBack", bowlBack, {x:0.95, y:-12.85, w:596.00, h: 118.00});
	$(this, "bowlFront", bowlFront, {x:0, y:0, w:656.00, h: 453.00});
	return this;
}
function iceCream1(this: $iceCream1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ice-cream-1.png", 0.500, 0.500);
	return this;
}
function iceCream2(this: $iceCream2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ice-cream-2.png", 0.500, 0.500);
	return this;
}
function iceCream3(this: $iceCream3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ice-cream-3.png", 0.500, 0.500);
	return this;
}
function toppingMask1(this: $toppingMask1) {
	return this;
}
function toppingMask2(this: $toppingMask2) {
	return this;
}
function toppingMask3(this: $toppingMask3) {
	return this;
}
function sprinklesColoured(this: $sprinklesColoured) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-coloured.png", 0.500, 0.500);
	return this;
}
function sprinklesChocolate(this: $sprinklesChocolate) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-chocolate.png", 0.500, 0.500);
	return this;
}
function sprinklesCoconut(this: $sprinklesCoconut) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-coconut.png", 0.500, 0.500);
	return this;
}
export function durianStep5(this: $durianStep5) {
	const toppings = this.toppings;
	$(toppings, 0, sprinklesColouredBowl, {x:-609.5, y:528.2, w:487.00, h: 243.00});
	$(toppings, 1, sprinklesChocolateBowl, {x:0, y:527, w:487.00, h: 243.00});
	$(toppings, 2, sprinklesCoconutBowl, {x:609.5, y:527, w:487.00, h: 243.00});
	const toppingsDrag = this.toppingsDrag;
	$(toppingsDrag, 0, sprinklesColouredDrag, {x:-459.3, y:-240.05, w:228.00, h: 189.00});
	$(toppingsDrag, 1, sprinklesChocolateDrag, {x:-173.45, y:-240.05, w:228.00, h: 189.00});
	$(toppingsDrag, 2, sprinklesCoconutDrag, {x:111.45, y:-240.05, w:228.00, h: 189.00});
	$(this, "bowlIceCream", bowlIceCream, {x:-17.3, y:145.75});
	return this;
}
function sprinklesChocolateBowl(this: $sprinklesChocolateBowl) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-chocolate-bowl.png", 0.500, 0.500);
	return this;
}
function sprinklesColouredBowl(this: $sprinklesColouredBowl) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-coloured-bowl.png", 0.500, 0.500);
	return this;
}
function sprinklesColouredDrag(this: $sprinklesColouredDrag) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-coloured-drag.png", 0.500, 0.500);
	return this;
}
function sprinklesChocolateDrag(this: $sprinklesChocolateDrag) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-chocolate-drag.png", 0.500, 0.500);
	return this;
}
function sprinklesCoconutBowl(this: $sprinklesCoconutBowl) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-coconut-bowl.png", 0.500, 0.500);
	return this;
}
function sprinklesCoconutDrag(this: $sprinklesCoconutDrag) {
	if (this.setLayoutTexture) this.setLayoutTexture("sprinkles-coconut-drag.png", 0.500, 0.500);
	return this;
}
export function durianStep6(this: $durianStep6) {
	$(this, "bowlIceCream", bowlIceCream, {x:-17.3, y:145.75});
	return this;
}
export function pastaStep1(this: $pastaStep1) {
	const noodlesOption = this.noodlesOption;
	$(noodlesOption, 0, noodlesOption1, {x:-465.6, y:163.8, w:234.00, h: 198.00});
	$(noodlesOption, 1, noodlesOption2, {x:-108.9, y:172.8, w:305.00, h: 138.00});
	$(noodlesOption, 2, noodlesOption3, {x:255.2, y:142.5, w:209.00, h: 179.00});
	$(noodlesOption, 3, noodlesOption4, {x:557.5, y:141, w:219.00, h: 143.00});
	$(noodlesOption, 4, noodlesOption5, {x:-583.4, y:438.6, w:302.00, h: 282.00});
	$(noodlesOption, 5, noodlesOption6, {x:-103.9, y:442.6, w:523.00, h: 288.00});
	$(noodlesOption, 6, noodlesOption7, {x:353.5, y:430.4, w:175.00, h: 193.00});
	$(noodlesOption, 7, noodlesOption8, {x:697, y:436.2, w:290.00, h: 133.00});
	return this;
}
function noodlesOption8(this: $noodlesOption8) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-8.png", 0.500, 0.500);
	return this;
}
function noodlesOption7(this: $noodlesOption7) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-7.png", 0.500, 0.500);
	return this;
}
function noodlesOption5(this: $noodlesOption5) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-5.png", 0.500, 0.500);
	return this;
}
function noodlesOption4(this: $noodlesOption4) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-4.png", 0.500, 0.500);
	return this;
}
function noodlesOption3(this: $noodlesOption3) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-3.png", 0.500, 0.500);
	return this;
}
function noodlesOption2(this: $noodlesOption2) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-2.png", 0.500, 0.500);
	return this;
}
function noodlesOption1(this: $noodlesOption1) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-option-1.png", 0.500, 0.500);
	return this;
}
export function pastaStep2(this: $pastaStep2) {
	const colors = this.colors;
	$(colors, 0, noodlesOption1, {x:-614.4, y:312, w:234.00, h: 198.00});
	$(colors, 1, noodlesOption1, {x:-204.8, y:310.2, w:234.00, h: 198.00});
	$(colors, 2, noodlesOption1, {x:204.8, y:310.2, w:234.00, h: 198.00});
	$(colors, 3, noodlesOption1, {x:614.4, y:310.2, w:234.00, h: 198.00});
	return this;
}
export function pastaStep4(this: $pastaStep4) {
	$(this, "pastaPlate", pastaPlate, {x:36.6, y:420.35, w:985.00, h: 735.00});
	$(this, "noodlesShape", noodlesShape, {x:31.2, y:392.1});
	$(this, "servingSpoon", servingSpoon, {x:32.25, y:313.45});
	$(this, "spoonInPot", servingSpoonSprite, {x:-262.25, y:-615.45, r:-0.0297, w:306.23, h: 230.30});
	return this;
}
function pastaPlate(this: $pastaPlate) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-plate.png", 0.500, 0.500);
	return this;
}
function noodlesShape(this: $noodlesShape) {
	const noodlesShape = this.noodlesShape;
	$(noodlesShape, 0, noodlesShape1, {x:6.45, y:1.65, w:868.00, h: 641.00});
	$(noodlesShape, 1, noodlesShape2, {x:-1.2, y:-0.9, w:852.00, h: 636.00});
	$(noodlesShape, 2, noodlesShape3, {x:-1.2, y:-0.9, w:843.00, h: 598.00});
	$(noodlesShape, 3, noodlesShape4, {x:-3.15, y:0.3, w:882.00, h: 643.00});
	$(noodlesShape, 4, noodlesShape5, {x:-13.5, y:1, w:928.00, h: 653.00});
	$(noodlesShape, 5, noodlesShape6, {x:-2.75, y:-4.5, w:864.00, h: 606.00});
	$(noodlesShape, 6, noodlesShape7, {x:-10, y:1.25, w:836.00, h: 595.00});
	$(noodlesShape, 7, noodlesShape8, {x:-9, y:-3.25, w:838.00, h: 586.00});
	return this;
}
function noodlesShape1(this: $noodlesShape1) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-1.png", 0.500, 0.500);
	return this;
}
function noodlesShape2(this: $noodlesShape2) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-2.png", 0.500, 0.500);
	return this;
}
function noodlesShape3(this: $noodlesShape3) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-3.png", 0.500, 0.500);
	return this;
}
function noodlesShape4(this: $noodlesShape4) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-4.png", 0.500, 0.500);
	return this;
}
function noodlesShape5(this: $noodlesShape5) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-5.png", 0.500, 0.500);
	return this;
}
function noodlesShape6(this: $noodlesShape6) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-6.png", 0.500, 0.500);
	return this;
}
function noodlesShape7(this: $noodlesShape7) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-7.png", 0.500, 0.500);
	return this;
}
function noodlesShape8(this: $noodlesShape8) {
	if (this.setLayoutTexture) this.setLayoutTexture("noodles-shape-8.png", 0.500, 0.500);
	return this;
}
function servingSpoon(this: $servingSpoon) {
	const spoonNoodles = this.spoonNoodles;
	$(spoonNoodles, 0, spoonNoodles1, {x:0, y:0});
	$(spoonNoodles, 1, spoonNoodles2, {x:-9.45, y:-2.15});
	$(spoonNoodles, 2, spoonNoodles3, {x:-9, y:-4.4});
	$(spoonNoodles, 3, spoonNoodles4, {x:-4.3, y:1.25});
	$(spoonNoodles, 4, spoonNoodles5, {x:13.3, y:-3.05});
	$(spoonNoodles, 5, spoonNoodles6, {x:-12.4, y:3.75});
	$(spoonNoodles, 6, spoonNoodles7, {x:1.95, y:2.75});
	$(spoonNoodles, 7, spoonNoodles8, {x:-7.15, y:5.6});
	$(this, "sprite", servingSpoonSprite, {x:0, y:0, w:730.00, h: 549.00});
	return this;
}
function servingSpoonSprite(this: $servingSpoonSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("serving-spoon.png", 0.190, 0.769);
	return this;
}
function spoonNoodles1(this: $spoonNoodles1) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption1, {x:-40.55, y:28.75, r:0.5588, w:141.77, h: 119.96});
	$(noodles, 1, noodlesOption1, {x:0.05, y:-38.55, r:0.1516, w:141.78, h: 119.97});
	$(noodles, 2, noodlesOption1, {x:31.35, y:11.95, r:-0.2618, w:141.78, h: 119.96});
	return this;
}
function spoonNoodles2(this: $spoonNoodles2) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption2, {x:39.25, y:3, r:-1.2952, w:184.77, h: 83.60});
	$(noodles, 1, noodlesOption2, {x:-8.55, y:4.1, r:-1.9860, w:184.78, h: 83.61});
	$(noodles, 2, noodlesOption2, {x:0, y:33.65, r:0.1004, w:184.80, h: 83.62});
	return this;
}
function spoonNoodles3(this: $spoonNoodles3) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption3, {x:63.05, y:-6.25, r:1.4213, w:126.62, h: 108.45});
	$(noodles, 1, noodlesOption3, {x:-11.45, y:-33.85, r:-0.2711, w:126.63, h: 108.45});
	$(noodles, 2, noodlesOption3, {x:-39.35, y:28.9, r:-0.3881, w:126.63, h: 108.46});
	$(noodles, 3, noodlesOption3, {x:5.65, y:34.75, r:0.2525, w:126.63, h: 108.45});
	return this;
}
function spoonNoodles4(this: $spoonNoodles4) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption4, {x:21.9, y:-29.85, r:1.8532, w:132.68, h: 86.64});
	$(noodles, 1, noodlesOption4, {x:-47.65, y:-26.7, r:2.0631, w:132.67, h: 86.63});
	$(noodles, 2, noodlesOption4, {x:-39.4, y:6.3, r:2.6439, w:147.14, h: 96.08});
	$(noodles, 3, noodlesOption4, {x:-6.3, y:53.75, r:2.9741, w:132.68, h: 86.63});
	$(noodles, 4, noodlesOption4, {x:32.8, y:-0.25, r:2.9789, w:145.71, h: 95.15});
	return this;
}
function spoonNoodles5(this: $spoonNoodles5) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption5, {x:-47.55, y:17.25, w:182.98, h: 170.86});
	$(noodles, 1, noodlesOption5, {x:10.9, y:-1.5, r:-1.0472, w:182.98, h: 170.86});
	return this;
}
function spoonNoodles6(this: $spoonNoodles6) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption6, {x:-1.2, y:-1.75, r:-0.2001, w:297.73, h: 163.95});
	return this;
}
function spoonNoodles7(this: $spoonNoodles7) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption7, {x:1.45, y:-3.9, r:-0.2618, w:106.02, h: 116.93});
	$(noodles, 1, noodlesOption7, {x:33.15, y:12.1, r:-2.0934, w:106.02, h: 116.92});
	$(noodles, 2, noodlesOption7, {x:16.5, y:-34.4, r:-2.7335, w:106.01, h: 116.92});
	$(noodles, 3, noodlesOption7, {x:-43.7, y:-23.05, r:1.8326, w:106.02, h: 116.93});
	$(noodles, 4, noodlesOption7, {x:-32.65, y:33.85, r:-0.2618, w:106.02, h: 116.93});
	return this;
}
function spoonNoodles8(this: $spoonNoodles8) {
	const noodles = this.noodles;
	$(noodles, 0, noodlesOption8, {x:33.8, y:-29.95, r:1.0522, w:175.69, h: 80.58});
	$(noodles, 1, noodlesOption8, {x:-0.45, y:-41.55, r:0.0787, w:175.70, h: 80.58});
	$(noodles, 2, noodlesOption8, {x:-32.6, y:27.55, r:0.5236, w:175.71, h: 80.58});
	$(noodles, 3, noodlesOption8, {x:22.45, y:11.55, r:-0.1831, w:175.71, h: 80.58});
	return this;
}
export function pastaStep5(this: $pastaStep5) {
	const sauceButton = this.sauceButton;
	$(sauceButton, 0, pastaSauce1, {x:-437.5, y:47.65, w:176.00, h: 272.00});
	$(sauceButton, 1, pastaSauce2, {x:-207.3, y:47.65, w:176.00, h: 272.00});
	$(sauceButton, 2, pastaSauce3, {x:22.9, y:47.65, w:176.00, h: 272.00});
	$(sauceButton, 3, pastaSauce4, {x:253.1, y:47.65, w:176.00, h: 272.00});
	$(sauceButton, 4, pastaSauce5, {x:483.3, y:47.65, w:176.00, h: 272.00});
	$(this, "pastaPlate", pastaPlate, {x:36.6, y:420.35, w:985.00, h: 735.00});
	$(this, "noodlesShape", noodlesShape, {x:31.2, y:392.1});
	$(this, "pastaSauce", pastaSauce, {x:30.5, y:375.2, w:690.00, h: 538.00});
	return this;
}
function pastaSauce(this: $pastaSauce) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-sauce.png", 0.500, 0.500);
	return this;
}
function pastaSauce5(this: $pastaSauce5) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-sauce-5.png", 0.500, 1.000);
	return this;
}
function pastaSauce4(this: $pastaSauce4) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-sauce-4.png", 0.500, 1.000);
	return this;
}
function pastaSauce3(this: $pastaSauce3) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-sauce-3.png", 0.500, 1.000);
	return this;
}
function pastaSauce2(this: $pastaSauce2) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-sauce-2.png", 0.500, 1.000);
	return this;
}
function pastaSauce1(this: $pastaSauce1) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-sauce-1.png", 0.500, 1.000);
	return this;
}
export function pastaStep6(this: $pastaStep6) {
	const toppingBowl = this.toppingBowl;
	$(toppingBowl, 0, toppingBowl1, {x:391.75, y:16.85, w:497.00, h: 295.00});
	$(toppingBowl, 1, toppingBowl2, {x:-709.9, y:351.65, w:376.00, h: 209.00});
	$(toppingBowl, 2, toppingBowl3, {x:-535.2, y:84.6, w:376.00, h: 244.00});
	$(toppingBowl, 3, toppingBowl4, {x:645.65, y:209.35, w:376.00, h: 205.00});
	$(toppingBowl, 4, toppingBowl5, {x:727.1, y:461.1, w:376.00, h: 224.00});
	$(toppingBowl, 5, toppingBowl6, {x:-719.1, y:627.85, w:376.00, h: 200.00});
	$(this, "pastaPlate", pastaPlate, {x:36.6, y:420.35, w:985.00, h: 735.00});
	$(this, "noodlesShape", noodlesShape, {x:31.2, y:392.1});
	$(this, "pastaSauce", pastaSauce, {x:30.5, y:375.2, w:690.00, h: 538.00});
	$(this, "pastaTopping", pastaTopping, {x:39.4, y:325.05});
	return this;
}
function pastaTopping(this: $pastaTopping) {
	const pastaTopping = this.pastaTopping;
	$(pastaTopping, 0, pastaTopping1, {x:0, y:0, w:560.00, h: 385.00});
	$(pastaTopping, 1, pastaTopping2, {x:-3.4, y:46.4, w:818.00, h: 487.00});
	$(pastaTopping, 2, pastaTopping3, {x:-8.85, y:13.8, w:624.00, h: 418.00});
	$(pastaTopping, 3, pastaTopping4, {x:-30.4, y:28.4, w:650.00, h: 423.00});
	$(pastaTopping, 4, pastaTopping5, {x:-19.8, y:24.65, w:544.00, h: 435.00});
	$(pastaTopping, 5, pastaTopping6, {x:-8.45, y:47.85, w:616.00, h: 471.00});
	return this;
}
function pastaTopping1(this: $pastaTopping1) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-topping-1.png", 0.500, 0.500);
	return this;
}
function pastaTopping2(this: $pastaTopping2) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-topping-2.png", 0.500, 0.500);
	return this;
}
function pastaTopping3(this: $pastaTopping3) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-topping-3.png", 0.500, 0.500);
	return this;
}
function pastaTopping4(this: $pastaTopping4) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-topping-4.png", 0.500, 0.500);
	return this;
}
function pastaTopping5(this: $pastaTopping5) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-topping-5.png", 0.500, 0.500);
	return this;
}
function pastaTopping6(this: $pastaTopping6) {
	if (this.setLayoutTexture) this.setLayoutTexture("pasta-topping-6.png", 0.500, 0.500);
	return this;
}
function toppingBowl1(this: $toppingBowl1) {
	if (this.setLayoutTexture) this.setLayoutTexture("topping-bowl-1.png", 0.501, 0.956);
	return this;
}
function toppingBowl3(this: $toppingBowl3) {
	if (this.setLayoutTexture) this.setLayoutTexture("topping-bowl-3.png", 0.500, 0.947);
	return this;
}
function toppingBowl2(this: $toppingBowl2) {
	if (this.setLayoutTexture) this.setLayoutTexture("topping-bowl-2.png", 0.500, 0.933);
	return this;
}
function toppingBowl4(this: $toppingBowl4) {
	if (this.setLayoutTexture) this.setLayoutTexture("topping-bowl-4.png", 0.500, 0.937);
	return this;
}
function toppingBowl6(this: $toppingBowl6) {
	if (this.setLayoutTexture) this.setLayoutTexture("topping-bowl-6.png", 0.500, 0.935);
	return this;
}
function toppingBowl5(this: $toppingBowl5) {
	if (this.setLayoutTexture) this.setLayoutTexture("topping-bowl-5.png", 0.500, 0.942);
	return this;
}
export function pastaStep7(this: $pastaStep7) {
	const pastaMask = this.pastaMask;
	$(pastaMask, 0, [-213.70,671.05,-185.20,615.85,-146.00,569.25,-116.90,548.40,-79.60,538.10,-40.90,534.90,-1.70,533.55,15.55,508.75,41.00,482.30,74.50,463.85,116.85,459.15,153.80,460.65,155.30,407.90,164.80,364.85,188.05,328.00,228.95,301.65,288.25,291.30,327.70,300.65,350.85,307.80,377.75,284.65,407.60,272.25,447.05,270.40,484.30,276.10,533.30,289.20,596.30,305.40,477.30,24.60,116.00,-80.80,-288.45,-39.50,-545.25,192.15,-577.45,407.50,-518.45,596.50,-391.90,724.65,-254.65,793.95]);
	$(pastaMask, 1, [-213.70,671.05,-185.20,615.85,-146.00,569.25,-116.90,548.40,-79.60,538.10,-40.90,534.90,-1.70,533.55,7.60,512.10,24.90,488.35,52.00,470.55,79.15,460.25,66.70,439.45,61.55,418.05,63.00,397.00,68.20,377.50,45.70,370.35,26.10,357.50,0.20,339.00,-18.30,313.10,-22.95,290.00,-23.85,265.00,-20.15,242.80,-7.20,219.65,-31.25,203.00,-54.40,179.90,-74.75,155.85,-89.55,123.45,-95.10,91.10,-94.15,57.80,-90.45,30.95,-112.25,-57.50,-288.45,-39.50,-545.25,192.15,-577.45,407.50,-518.45,596.50,-391.90,724.65,-254.65,793.95]);
	$(this, "pastaPlate", pastaPlate, {x:36.6, y:420.35, w:985.00, h: 735.00});
	$(this, "noodlesShape", noodlesShape, {x:31.2, y:392.1});
	$(this, "pastaSauce", pastaSauce, {x:30.5, y:375.2, w:690.00, h: 538.00});
	$(this, "pastaTopping", pastaTopping, {x:39.4, y:325.05});
	return this;
}
function pastaMask1(this: $pastaMask1) {
	return this;
}
function pastaMask2(this: $pastaMask2) {
	return this;
}
export function delightStep1(this: $delightStep1) {
	const colorBottles = this.colorBottles;
	$(colorBottles, 0, colorBottlePink, {x:-589.9, y:156.35});
	$(colorBottles, 1, colorBottleGreen, {x:-725.6, y:-35.1});
	$(colorBottles, 2, colorBottlePurple, {x:-448.1, y:-138.3});
	$(this, "cuttingBoard", cuttingBoard, {x:264.2, y:210.9, w:1414.18, h: 589.43});
	$(this, "bowlMix", bakingDishMix, {x:303.15, y:88.55});
	$(this, "ingredientWaterJug", ingredientWaterJug, {x:63.6, y:336.75});
	$(this, "ingredientSugarBowl", ingredientSugarBowl, {x:-513.7, y:427.35});
	$(this, "ingredientCornStarch", ingredientCornStarch, {x:552.8, y:512.95});
	$(this, "arrow", arrow, {x:-517.85, y:357.5, w:288.00, h: 310.00});
	$(this, "arrowEnd", arrow, {x:305, y:-101.8, w:288.00, h: 310.00});
	return this;
}
function bakingDishMix(this: $bakingDishMix) {
	$(this, "bowlBack", backingDishBack, {x:12.35, y:-28.75, w:909.00, h: 321.00});
	$(this, "spoon", spoon, {x:6.7, y:-201.25, w:131.00, h: 577.00});
	$(this, "bowlContent", backingDishContent, {x:13.85, y:127.2, w:802.00, h: 156.00});
	$(this, "bowlFront", backingDishFront, {x:0, y:0, w:1039.00, h: 359.00});
	return this;
}
function backingDishBack(this: $backingDishBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("backing-dish-back.png", 0.500, 0.500);
	return this;
}
function backingDishContent(this: $backingDishContent) {
	if (this.setLayoutTexture) this.setLayoutTexture("backing-dish-content.png", 0.500, 0.910);
	return this;
}
function backingDishFront(this: $backingDishFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("backing-dish-front.png", 0.500, 0.500);
	return this;
}
function ingredientWaterJug(this: $ingredientWaterJug) {
	$(this, "sprite", ingredientWaterJugSprite, {x:-41.5, y:156.5, w:417.00, h: 389.00});
	$(this, "pouringPoint", pouringPoint, {x:111.7, y:-9.2, w:20.00, h:20.00});
	return this;
}
function ingredientWaterJugSprite(this: $ingredientWaterJugSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("ingredient-water-jug.png", 0.500, 0.500);
	return this;
}
function ingredientSugarBowl(this: $ingredientSugarBowl) {
	$(this, "sprite", ingredientSugarBowlSprite, {x:0, y:91.5, w:420.00, h: 257.00});
	$(this, "pouringPoint", pouringPoint, {x:187.25, y:-9.45, w:20.00, h:20.00});
	return this;
}
function ingredientSugarBowlSprite(this: $ingredientSugarBowlSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("ingredient-sugar-bowl.png", 0.500, 0.500);
	return this;
}
function ingredientCornStarch(this: $ingredientCornStarch) {
	$(this, "sprite", ingredientCornStarchSprite, {x:0, y:41.5, w:372.00, h: 185.00});
	$(this, "pouringPoint", pouringPoint, {x:124.15, y:16.65, w:20.00, h:20.00});
	return this;
}
function ingredientCornStarchSprite(this: $ingredientCornStarchSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("ingredient-corn-starch.png", 0.500, 0.500);
	return this;
}
function colorBottlePurple(this: $colorBottlePurple) {
	$(this, "sprite", colorBottlePurpleSprite, {x:-0.5, y:81, w:121.00, h: 306.00});
	$(this, "pouringPoint", pouringPoint, {x:-7.55, y:-67.25, w:20.00, h:20.00});
	return this;
}
function colorBottlePurpleSprite(this: $colorBottlePurpleSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("color-bottle-purple.png", 0.500, 0.500);
	return this;
}
function colorBottleGreen(this: $colorBottleGreen) {
	$(this, "sprite", colorBottleGreenSprite, {x:-0.5, y:81, w:121.00, h: 306.00});
	$(this, "pouringPoint", pouringPoint, {x:-7.55, y:-67.25, w:20.00, h:20.00});
	return this;
}
function colorBottleGreenSprite(this: $colorBottleGreenSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("color-bottle-green.png", 0.500, 0.500);
	return this;
}
function colorBottlePink(this: $colorBottlePink) {
	$(this, "sprite", colorBottlePinkSprite, {x:-0.5, y:81, w:121.00, h: 306.00});
	$(this, "pouringPoint", pouringPoint, {x:-7.55, y:-67.25, w:20.00, h:20.00});
	return this;
}
function colorBottlePinkSprite(this: $colorBottlePinkSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("color-bottle-pink.png", 0.500, 0.500);
	return this;
}
export function delightStep2(this: $delightStep2) {
	$(this, "bowlMix", bakingDishMix, {x:0, y:211.75});
	$(this, "spoon", spoon, {x:-25.4, y:548.2, r:1.6200, w:130.99, h: 576.95});
	$(this, "spoonTop", spoon, {x:2, y:-189.7, w:131.00, h: 577.00});
	return this;
}
export function delightStep3(this: $delightStep3) {
	$(this, "bowlCook", bakingDishCooked, {x:0, y:288});
	$(this, "bowlMix", bakingDishMix, {x:-269.2, y:-271.1, sx:0.318, sy:0.318});
	return this;
}
function bakingDishCooked(this: $bakingDishCooked) {
	$(this, "bowlBack", backingDishBack, {x:12.35, y:-28.75, w:909.00, h: 321.00});
	$(this, "bowlContent", turkishDelightCooked, {x:11.55, y:133.25, w:788.00, h: 269.00});
	$(this, "bowlFront", backingDishFront, {x:0, y:0, w:1039.00, h: 359.00});
	return this;
}
function turkishDelightCooked(this: $turkishDelightCooked) {
	if (this.setLayoutTexture) this.setLayoutTexture("turkish-delight-cooked.png", 0.500, 1.000);
	return this;
}
export function delightStep4(this: $delightStep4) {
	$(this, "bowlCook", bakingDishCooked, {x:0, y:288});
	$(this, "jelly", backedDelight, {x:0, y:421.35});
	$(this, "pieces", delightPieces, {x:-226.3, y:275.6});
	return this;
}
function backedDelight(this: $backedDelight) {
	const pieces = this.pieces;
	$(pieces, 0, turkishDelightPiece, {x:-240.45, y:-178.55});
	$(pieces, 1, turkishDelightPiece, {x:-298.85, y:-95.9});
	$(pieces, 2, turkishDelightPiece, {x:-100.55, y:-178.55});
	$(pieces, 3, turkishDelightPiece, {x:-155.8, y:-95.9});
	$(pieces, 4, turkishDelightPiece, {x:39.35, y:-178.55});
	$(pieces, 5, turkishDelightPiece, {x:-12.75, y:-95.9});
	$(pieces, 6, turkishDelightPiece, {x:179.25, y:-178.55});
	$(pieces, 7, turkishDelightPiece, {x:130.3, y:-95.9});
	$(pieces, 8, turkishDelightPiece, {x:319.2, y:-178.55});
	$(pieces, 9, turkishDelightPiece, {x:273.5, y:-95.9});
	$(this, "sprite", turkishDelightCooked, {x:11.55, y:0, w:788.00, h: 269.00});
	$(this, "piecesMask", [-172.20,-250.70,-205.30,-232.90,-231.20,-189.50,-240.40,-139.00,-257.10,-109.60,-282.50,-90.20,-296.30,-64.30,-298.50,-27.30,-323.90,49.85,514.95,49.85,514.95,-310.75,-131.70,-310.75]);
	return this;
}
function piecesMask(this: $piecesMask) {
	return this;
}
function turkishDelightPiece(this: $turkishDelightPiece) {
	$(this, "sprite", delightPieceSprite, {x:0, y:0, w:174.00, h: 178.00});
	$(this, "topping", turkishDelightPiecePowder, {x:0.5, y:-46, w:210.00, h: 119.00});
	return this;
}
function delightPieceSprite(this: $delightPieceSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("turkish-delight-piece.png", 0.500, 0.500);
	return this;
}
function turkishDelightPiecePowder(this: $turkishDelightPiecePowder) {
	if (this.setLayoutTexture) this.setLayoutTexture("turkish-delight-piece-powder.png", 0.500, 0.500);
	return this;
}
function delightPieces(this: $delightPieces) {
	const pieces = this.pieces;
	$(pieces, 0, turkishDelightPiece, {x:-251.3, y:59.25});
	$(pieces, 1, turkishDelightPiece, {x:-153.4, y:106});
	$(pieces, 2, turkishDelightPiece, {x:-150.85, y:17});
	$(pieces, 3, turkishDelightPiece, {x:-52.95, y:63.75});
	$(pieces, 4, turkishDelightPiece, {x:-48.15, y:-24.05});
	$(pieces, 5, turkishDelightPiece, {x:49.75, y:22.7});
	$(pieces, 6, turkishDelightPiece, {x:52.6, y:-63.9});
	$(pieces, 7, turkishDelightPiece, {x:150.5, y:-17.15});
	$(pieces, 8, turkishDelightPiece, {x:153.4, y:-105.95});
	$(pieces, 9, turkishDelightPiece, {x:251.3, y:-59.2});
	return this;
}
export function delightStep5(this: $delightStep5) {
	$(this, "sugar", sugarTable, {x:-30.5, y:334, w:1683.00, h: 418.00});
	$(this, "sugarBag", sugarBag, {x:634, y:-11.5, w:456.00, h: 423.00});
	$(this, "sugarDrag", sugarDrag, {x:627.9, y:63.35, w:288.00, h: 174.00});
	$(this, "pieces", delightPiecesOrdered, {x:-62.9, y:275.6});
	return this;
}
function sugarTable(this: $sugarTable) {
	if (this.setLayoutTexture) this.setLayoutTexture("sugar-table.png", 0.500, 0.500);
	return this;
}
function sugarBag(this: $sugarBag) {
	if (this.setLayoutTexture) this.setLayoutTexture("sugar-bag.png", 0.500, 0.500);
	return this;
}
function sugarDrag(this: $sugarDrag) {
	if (this.setLayoutTexture) this.setLayoutTexture("sugar-drag.png", 0.500, 0.500);
	return this;
}
function delightPiecesOrdered(this: $delightPiecesOrdered) {
	const pieces = this.pieces;
	$(pieces, 0, turkishDelightPiece, {x:153.4, y:-105.95});
	$(pieces, 1, turkishDelightPiece, {x:251.3, y:-59.2});
	$(pieces, 2, turkishDelightPiece, {x:52.6, y:-63.9});
	$(pieces, 3, turkishDelightPiece, {x:150.5, y:-17.15});
	$(pieces, 4, turkishDelightPiece, {x:-48.15, y:-24.05});
	$(pieces, 5, turkishDelightPiece, {x:49.75, y:22.7});
	$(pieces, 6, turkishDelightPiece, {x:-150.85, y:17});
	$(pieces, 7, turkishDelightPiece, {x:-52.95, y:63.75});
	$(pieces, 8, turkishDelightPiece, {x:-251.3, y:59.25});
	$(pieces, 9, turkishDelightPiece, {x:-153.4, y:106});
	return this;
}
export function delightStep6(this: $delightStep6) {
	$(this, "box", turkishDelightBox, {x:-402.5, y:152.5});
	$(this, "pieces", delightPiecesOrdered, {x:343.9, y:239.6});
	$(this, "arrow", arrow, {x:286.1, y:74.85, w:288.00, h: 310.00});
	$(this, "arrowEnd", arrow, {x:-397.15, y:-171.7, w:288.00, h: 310.00});
	return this;
}
function turkishDelightBox(this: $turkishDelightBox) {
	const pieces = this.pieces;
	$(pieces, 0, turkishDelightPiece, {x:-111.85, y:-124.35});
	$(pieces, 1, turkishDelightPiece, {x:114.35, y:-117.35});
	$(pieces, 2, turkishDelightPiece, {x:-236.4, y:-58.05});
	$(pieces, 3, turkishDelightPiece, {x:9.55, y:-54.05});
	$(pieces, 4, turkishDelightPiece, {x:232.45, y:-51.05});
	$(pieces, 5, turkishDelightPiece, {x:-119, y:5.9});
	$(pieces, 6, turkishDelightPiece, {x:113.8, y:4.9});
	$(pieces, 7, turkishDelightPiece, {x:-254.5, y:56.65});
	$(pieces, 8, turkishDelightPiece, {x:-14.45, y:69.05});
	$(pieces, 9, turkishDelightPiece, {x:211.9, y:67.1});
	$(this, "sprite", turkishDelightBoxSprite, {x:0, y:0, w:889.00, h: 1129.00});
	$(this, "piecesMask", [-388.20,-18.40,-329.90,46.25,-278.90,89.25,-247.00,96.45,-173.70,105.20,-83.65,112.40,120.35,119.55,157.00,116.35,180.10,109.20,246.25,70.15,319.60,12.75,404.85,-65.30,693.15,-490.60,693.15,-895.60,-695.10,-895.60,-695.10,-471.15,-429.50,-73.40]);
	return this;
}
function turkishDelightBoxSprite(this: $turkishDelightBoxSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("turkish-delight-box.png", 0.501, 0.777);
	return this;
}
function boxPiecesMask(this: $boxPiecesMask) {
	return this;
}
export function delightStep7(this: $delightStep7) {
	$(this, "box", turkishDelightBox, {x:-11.3, y:307.35});
	return this;
}
export function coconutStep1(this: $coconutStep1) {
	$(this, "cuttingBoard", cuttingBoard, {x:-4.5, y:344, w:1481.00, h: 730.00});
	$(this, "coconutCut", coconutCut, {x:-11.3, y:84.55});
	return this;
}
function coconutCut(this: $coconutCut) {
	const bottom = this.bottom;
	$(bottom, 0, coconutBottom, {x:106.55, y:-6.8, r:-1.5707, w:691.96, h: 649.96});
	$(bottom, 1, coconutBottom, {x:54.55, y:-19.9, r:-0.4616, w:691.89, h: 649.90});
	$(bottom, 2, coconutBottom, {x:0, y:0, r:-0.0000, w:691.94, h: 649.94});
	const top = this.top;
	$(top, 0, coconutTop, {x:-149.35, y:-11.6, w:612.00, h: 713.98});
	$(top, 1, coconutTop, {x:-295.35, y:-279.05, r:0.3840, w:611.98, h: 713.93});
	$(top, 2, coconutTop, {x:-640.55, y:57.95, r:-1.9995, w:550.09, h: 641.77});
	$(this, "sprite", coconutWhole, {x:0, y:0, w:787.00, h: 675.00});
	return this;
}
function coconutWhole(this: $coconutWhole) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-whole.png", 0.500, 0.500);
	return this;
}
function coconutBottom(this: $coconutBottom) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-bottom.png", 0.500, 0.500);
	return this;
}
function coconutTop(this: $coconutTop) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-top.png", 0.500, 0.500);
	return this;
}
export function coconutStep2(this: $coconutStep2) {
	$(this, "coconutHalf", coconutHalf, {x:-483.45, y:-87.25, sx:0.900, sy:0.900});
	$(this, "glass", glass, {x:48, y:328.8});
	return this;
}
function coconutHalf(this: $coconutHalf) {
	$(this, "sprite", coconutBottom, {x:0, y:0, r:-0.0000, w:691.94, h: 649.94});
	$(this, "empty", coconutEmpty, {x:0, y:325, w:692.00, h: 650.00});
	$(this, "pouringPoint", pouringPoint, {x:252.05, y:-124.25, w:20.00, h:20.00});
	return this;
}
function coconutEmpty(this: $coconutEmpty) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-empty.png", 0.500, 1.000);
	return this;
}
function glass(this: $glass) {
	$(this, "glassBack", glassBack, {x:0, y:2.75, w:420.00, h: 600.00});
	$(this, "drinkBack", drinkBack, {x:-22.3, y:-38.4, w:266.00, h: 303.00});
	$(this, "straw", straw1, {x:101.6, y:-228.85, r:-1.2386, w:545.99, h: 70.00});
	$(this, "strawBottom", straw1, {x:94.55, y:19.05, r:-1.3249, w:545.98, h: 70.00});
	$(this, "drinkFront", drinkFront, {x:17.2, y:66.35, w:345.00, h: 460.00});
	$(this, "drinkMask", [-71.00,255.05,-35.50,259.70,4.05,259.40,34.90,258.45,56.85,252.30,78.45,241.45,99.75,225.70,109.05,210.60,118.60,178.80,133.45,80.30,146.10,-7.20,161.20,-102.00,173.90,-234.20,-174.70,-231.35,-156.60,-91.25,-153.65,-42.30,-136.35,117.55,-132.45,168.75,-127.60,196.80,-118.90,221.45,-111.20,232.55,-102.00,240.30,-92.00,246.40]);
	$(this, "glassFront", glassFront, {x:0, y:24.7, w:426.00, h: 563.00});
	return this;
}
function glassBack(this: $glassBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("glass-back.png", 0.500, 0.500);
	return this;
}
function drinkBack(this: $drinkBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("drink-back.png", 0.500, 0.500);
	return this;
}
function straw1(this: $straw1) {
	if (this.setLayoutTexture) this.setLayoutTexture("straw-1.png", 0.500, 0.500);
	return this;
}
function drinkFront(this: $drinkFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("drink-front.png", 0.500, 0.500);
	return this;
}
function drinkMask(this: $drinkMask) {
	return this;
}
function glassFront(this: $glassFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("glass-front.png", 0.500, 0.500);
	return this;
}
export function coconutStep3(this: $coconutStep3) {
	$(this, "coconutHalf", coconutHalf, {x:-72.9, y:-87.25, sx:0.900, sy:0.900});
	$(this, "glass", glass, {x:-669.85, y:328.8});
	$(this, "bowl", coconutBowl, {x:-102.1, y:495.65});
	$(this, "coconutMeat", coconutMeat1, {x:509.65, y:-374, w:583.00, h: 217.00});
	return this;
}
function coconutBowl(this: $coconutBowl) {
	const coconutMeat = this.coconutMeat;
	$(coconutMeat, 0, coconutMeat1, {x:7.65, y:-142, w:583.00, h: 217.00});
	$(coconutMeat, 1, coconutMeat2, {x:-93.35, y:-142, w:382.00, h: 217.00});
	$(coconutMeat, 2, coconutMeat3, {x:-150.35, y:-143, w:267.00, h: 183.00});
	$(this, "bowlBack", coconutBowlBack, {x:1.75, y:-143.3, w:636.00, h: 105.00});
	$(this, "bowlFront", coconutBowlFront, {x:0, y:0, w:639.00, h: 294.00});
	return this;
}
function coconutBowlBack(this: $coconutBowlBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-bowl-back.png", 0.500, 0.500);
	return this;
}
function coconutMeat1(this: $coconutMeat1) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-meat-1.png", 0.501, 0.502);
	return this;
}
function coconutMeat2(this: $coconutMeat2) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-meat-2.png", 0.500, 0.502);
	return this;
}
function coconutMeat3(this: $coconutMeat3) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-meat-3.png", 0.502, 0.503);
	return this;
}
function coconutBowlFront(this: $coconutBowlFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-bowl-front.png", 0.500, 0.500);
	return this;
}
export function coconutStep4(this: $coconutStep4) {
	$(this, "coconutHalf", coconutHalf, {x:625.4, y:-87.25, sx:0.900, sy:0.900});
	$(this, "fiber", coconutFibers, {x:589.5, y:403.5, w:675.00, h: 467.00});
	$(this, "glass", glass, {x:-669.85, y:328.8});
	$(this, "bowl", coconutBowl, {x:-102.1, y:495.65});
	return this;
}
function coconutFibers(this: $coconutFibers) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-fibers.png", 0.500, 0.500);
	return this;
}
export function coconutStep5(this: $coconutStep5) {
	const straw = this.straw;
	$(straw, 0, straw1, {x:-644.5, y:592.4, w:546.00, h: 70.00});
	$(straw, 1, straw2, {x:-601.6, y:494.15, w:547.00, h: 69.00});
	$(straw, 2, straw3, {x:-554, y:397.75, w:547.00, h: 69.00});
	$(straw, 3, straw4, {x:-520.3, y:307.3, w:546.00, h: 69.00});
	$(this, "glass", glass, {x:-451.95, y:-52.8, sx:0.850, sy:0.850});
	$(this, "bowl", coconutBowl, {x:310.45, y:71.7, sx:0.850, sy:0.850});
	$(this, "strawTop", straw1, {x:-310.45, y:-484.05, r:-0.9416, w:545.97, h: 70.00});
	$(this, "fiber", coconutFibers, {x:362.75, y:440.95, w:675.00, h: 466.99});
	$(this, "rope", coconutFiberRope, {x:354.5, y:495.5, w:1059.00, h: 63.00});
	return this;
}
function straw4(this: $straw4) {
	if (this.setLayoutTexture) this.setLayoutTexture("straw-4.png", 0.500, 0.500);
	return this;
}
function straw3(this: $straw3) {
	if (this.setLayoutTexture) this.setLayoutTexture("straw-3.png", 0.500, 0.500);
	return this;
}
function straw2(this: $straw2) {
	if (this.setLayoutTexture) this.setLayoutTexture("straw-2.png", 0.500, 0.500);
	return this;
}
function coconutFiberRope(this: $coconutFiberRope) {
	if (this.setLayoutTexture) this.setLayoutTexture("coconut-fiber-rope.png", 0.500, 0.500);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $KitchenScreenLayout {
	readonly durianStep: $$array<$durianStep1|$durianStep2|$durianStep3|$durianStep4|$durianStep5|$durianStep6>;
	readonly pastaStep: $$array<$pastaStep1|$pastaStep2|$pastaStep4|$pastaStep5|$pastaStep6|$pastaStep7>;
	readonly delightStep: $$array<$delightStep1|$delightStep2|$delightStep3|$delightStep4|$delightStep5|$delightStep6|$delightStep7>;
	readonly coconutStep: $$array<$coconutStep1|$coconutStep2|$coconutStep3|$coconutStep4|$coconutStep5>;
	readonly main: $main;
	readonly pastaStepBase: $pastaStepBase;
}
interface $main extends $$container {
	readonly background: $background;
	readonly freezer: $freezer;
	readonly oven: $oven;
	readonly freezerTimerPosition: $timerPoint;
	readonly ovenTimerPosition: $timerPoint;
	readonly timer: $timer;
	readonly potTimerPosition: $timerPoint;
	readonly luna: $luna;
}
interface $background extends $$sprite {
}
interface $freezer extends $$container {
	readonly frames: $$array<$freezerDoor2|$freezerDoor3>;
	readonly sprite: $freezerDoor1;
}
interface $freezerDoor1 extends $$sprite {
}
interface $freezerDoor2 extends $$sprite {
}
interface $freezerDoor3 extends $$sprite {
}
interface $oven extends $$container {
	readonly frames: $$array<$ovenDoor2|$ovenDoor3>;
	readonly sprite: $ovenDoor1;
}
interface $ovenDoor1 extends $$sprite {
}
interface $ovenDoor2 extends $$sprite {
}
interface $ovenDoor3 extends $$sprite {
}
interface $timerPoint extends $$sprite {
}
interface $timer extends $$container {
	readonly base: $freezerTimerBase;
	readonly circle: $freezerTimerFill;
	readonly stroke: $freezerTimerStroke;
}
interface $freezerTimerBase extends $$sprite {
}
interface $freezerTimerFill extends $$container {
}
interface $freezerTimerStroke extends $$sprite {
}
interface $luna extends $$sprite {
}
interface $pastaStepBase extends $$container {
	readonly pastaPot: $pastaPot;
}
interface $pastaPot extends $$container {
	readonly pastaPotBack: $pastaPotBack;
	readonly noodles: $noodlesOption6;
	readonly pastaPotFront: $pastaPotFront;
	readonly bubblesBounds: $bubblesBounds;
}
interface $pastaPotBack extends $$sprite {
}
interface $noodlesOption6 extends $$sprite {
}
interface $pastaPotFront extends $$sprite {
}
interface $bubblesBounds extends $$container {
}
interface $durianStep1 extends $$container {
	readonly cuttingBoard: $cuttingBoard;
	readonly durianCut: $durianCut;
}
interface $cuttingBoard extends $$sprite {
}
interface $durianCut extends $$container {
	readonly sprite: $durianWhole;
	readonly durianEmpty: $durianEmpty;
	readonly durianFruit: $durianFruit;
	readonly durianTop: $durianTop;
}
interface $durianWhole extends $$sprite {
}
interface $durianEmpty extends $$sprite {
}
interface $durianFruit extends $$sprite {
}
interface $durianTop extends $$sprite {
}
interface $durianStep2 extends $$container {
	readonly durianOpen: $durianOpen;
	readonly ingredientVanilla: $ingredientVanilla;
	readonly ingredientSugar: $ingredientSugar;
	readonly ingredientCream: $ingredientCream;
	readonly bowlMix: $bowlMix;
	readonly arrow: $arrow;
	readonly arrowEnd: $arrow;
}
interface $durianOpen extends $$container {
	readonly durianEmpty: $durianEmpty;
	readonly durianFruit: $durianFruit;
}
interface $ingredientVanilla extends $$container {
	readonly sprite: $ingredientVanillaSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $ingredientVanillaSprite extends $$sprite {
}
interface $pouringPoint extends $$container {
}
interface $ingredientSugar extends $$container {
	readonly sprite: $ingredientSugarSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $ingredientSugarSprite extends $$sprite {
}
interface $ingredientCream extends $$container {
	readonly sprite: $ingredientCreamSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $ingredientCreamSprite extends $$sprite {
}
interface $bowlMix extends $$container {
	readonly bowlBack: $bowlBack;
	readonly bowlContent: $bowlContent;
	readonly spoon: $spoon;
	readonly bowlFront: $bowlFront;
}
interface $bowlBack extends $$sprite {
}
interface $bowlContent extends $$sprite {
}
interface $spoon extends $$sprite {
}
interface $bowlFront extends $$sprite {
}
interface $arrow extends $$sprite {
}
interface $durianStep3 extends $$container {
	readonly bowlMix: $bowlMix;
	readonly spoon: $spoon;
	readonly spoonTop: $spoon;
}
interface $durianStep4 extends $$container {
	readonly bowlMix: $bowlMix;
	readonly bowlCook: $bowlIceCream;
}
interface $bowlIceCream extends $$container {
	readonly iceCream: $$array<$iceCream1|$iceCream2|$iceCream3>;
	readonly toppingMask: $$array<$toppingMask1|$toppingMask2|$toppingMask3>;
	readonly toppings: $$array<$sprinklesColoured|$sprinklesChocolate|$sprinklesCoconut>;
	readonly bowlBack: $bowlBack;
	readonly bowlFront: $bowlFront;
}
interface $iceCream1 extends $$sprite {
}
interface $iceCream2 extends $$sprite {
}
interface $iceCream3 extends $$sprite {
}
interface $toppingMask1 extends $$polygon {
}
interface $toppingMask2 extends $$polygon {
}
interface $toppingMask3 extends $$polygon {
}
interface $sprinklesColoured extends $$sprite {
}
interface $sprinklesChocolate extends $$sprite {
}
interface $sprinklesCoconut extends $$sprite {
}
interface $durianStep5 extends $$container {
	readonly toppings: $$array<$sprinklesColouredBowl|$sprinklesChocolateBowl|$sprinklesCoconutBowl>;
	readonly toppingsDrag: $$array<$sprinklesColouredDrag|$sprinklesChocolateDrag|$sprinklesCoconutDrag>;
	readonly bowlIceCream: $bowlIceCream;
}
interface $sprinklesChocolateBowl extends $$sprite {
}
interface $sprinklesColouredBowl extends $$sprite {
}
interface $sprinklesColouredDrag extends $$sprite {
}
interface $sprinklesChocolateDrag extends $$sprite {
}
interface $sprinklesCoconutBowl extends $$sprite {
}
interface $sprinklesCoconutDrag extends $$sprite {
}
interface $durianStep6 extends $$container {
	readonly bowlIceCream: $bowlIceCream;
}
interface $pastaStep1 extends $$container {
	readonly noodlesOption: $$array<$noodlesOption1|$noodlesOption2|$noodlesOption3|$noodlesOption4|$noodlesOption5|$noodlesOption6|$noodlesOption7|$noodlesOption8>;
}
interface $noodlesOption8 extends $$sprite {
}
interface $noodlesOption7 extends $$sprite {
}
interface $noodlesOption5 extends $$sprite {
}
interface $noodlesOption4 extends $$sprite {
}
interface $noodlesOption3 extends $$sprite {
}
interface $noodlesOption2 extends $$sprite {
}
interface $noodlesOption1 extends $$sprite {
}
interface $pastaStep2 extends $$container {
	readonly colors: $$array<$noodlesOption1>;
}
interface $pastaStep4 extends $$container {
	readonly pastaPlate: $pastaPlate;
	readonly noodlesShape: $noodlesShape;
	readonly servingSpoon: $servingSpoon;
	readonly spoonInPot: $servingSpoonSprite;
}
interface $pastaPlate extends $$sprite {
}
interface $noodlesShape extends $$container {
	readonly noodlesShape: $$array<$noodlesShape1|$noodlesShape2|$noodlesShape3|$noodlesShape4|$noodlesShape5|$noodlesShape6|$noodlesShape7|$noodlesShape8>;
}
interface $noodlesShape1 extends $$sprite {
}
interface $noodlesShape2 extends $$sprite {
}
interface $noodlesShape3 extends $$sprite {
}
interface $noodlesShape4 extends $$sprite {
}
interface $noodlesShape5 extends $$sprite {
}
interface $noodlesShape6 extends $$sprite {
}
interface $noodlesShape7 extends $$sprite {
}
interface $noodlesShape8 extends $$sprite {
}
interface $servingSpoon extends $$container {
	readonly spoonNoodles: $$array<$spoonNoodles1|$spoonNoodles2|$spoonNoodles3|$spoonNoodles4|$spoonNoodles5|$spoonNoodles6|$spoonNoodles7|$spoonNoodles8>;
	readonly sprite: $servingSpoonSprite;
}
interface $servingSpoonSprite extends $$sprite {
}
interface $spoonNoodles1 extends $$container {
	readonly noodles: $$array<$noodlesOption1>;
}
interface $spoonNoodles2 extends $$container {
	readonly noodles: $$array<$noodlesOption2>;
}
interface $spoonNoodles3 extends $$container {
	readonly noodles: $$array<$noodlesOption3>;
}
interface $spoonNoodles4 extends $$container {
	readonly noodles: $$array<$noodlesOption4>;
}
interface $spoonNoodles5 extends $$container {
	readonly noodles: $$array<$noodlesOption5>;
}
interface $spoonNoodles6 extends $$container {
	readonly noodles: $$array<$noodlesOption6>;
}
interface $spoonNoodles7 extends $$container {
	readonly noodles: $$array<$noodlesOption7>;
}
interface $spoonNoodles8 extends $$container {
	readonly noodles: $$array<$noodlesOption8>;
}
interface $pastaStep5 extends $$container {
	readonly sauceButton: $$array<$pastaSauce1|$pastaSauce2|$pastaSauce3|$pastaSauce4|$pastaSauce5>;
	readonly pastaPlate: $pastaPlate;
	readonly noodlesShape: $noodlesShape;
	readonly pastaSauce: $pastaSauce;
}
interface $pastaSauce extends $$sprite {
}
interface $pastaSauce5 extends $$sprite {
}
interface $pastaSauce4 extends $$sprite {
}
interface $pastaSauce3 extends $$sprite {
}
interface $pastaSauce2 extends $$sprite {
}
interface $pastaSauce1 extends $$sprite {
}
interface $pastaStep6 extends $$container {
	readonly toppingBowl: $$array<$toppingBowl1|$toppingBowl2|$toppingBowl3|$toppingBowl4|$toppingBowl5|$toppingBowl6>;
	readonly pastaPlate: $pastaPlate;
	readonly noodlesShape: $noodlesShape;
	readonly pastaSauce: $pastaSauce;
	readonly pastaTopping: $pastaTopping;
}
interface $pastaTopping extends $$container {
	readonly pastaTopping: $$array<$pastaTopping1|$pastaTopping2|$pastaTopping3|$pastaTopping4|$pastaTopping5|$pastaTopping6>;
}
interface $pastaTopping1 extends $$sprite {
}
interface $pastaTopping2 extends $$sprite {
}
interface $pastaTopping3 extends $$sprite {
}
interface $pastaTopping4 extends $$sprite {
}
interface $pastaTopping5 extends $$sprite {
}
interface $pastaTopping6 extends $$sprite {
}
interface $toppingBowl1 extends $$sprite {
}
interface $toppingBowl3 extends $$sprite {
}
interface $toppingBowl2 extends $$sprite {
}
interface $toppingBowl4 extends $$sprite {
}
interface $toppingBowl6 extends $$sprite {
}
interface $toppingBowl5 extends $$sprite {
}
interface $pastaStep7 extends $$container {
	readonly pastaMask: $$array<$pastaMask1|$pastaMask2>;
	readonly pastaPlate: $pastaPlate;
	readonly noodlesShape: $noodlesShape;
	readonly pastaSauce: $pastaSauce;
	readonly pastaTopping: $pastaTopping;
}
interface $pastaMask1 extends $$polygon {
}
interface $pastaMask2 extends $$polygon {
}
interface $delightStep1 extends $$container {
	readonly colorBottles: $$array<$colorBottlePink|$colorBottleGreen|$colorBottlePurple>;
	readonly cuttingBoard: $cuttingBoard;
	readonly bowlMix: $bakingDishMix;
	readonly ingredientWaterJug: $ingredientWaterJug;
	readonly ingredientSugarBowl: $ingredientSugarBowl;
	readonly ingredientCornStarch: $ingredientCornStarch;
	readonly arrow: $arrow;
	readonly arrowEnd: $arrow;
}
interface $bakingDishMix extends $$container {
	readonly bowlBack: $backingDishBack;
	readonly spoon: $spoon;
	readonly bowlContent: $backingDishContent;
	readonly bowlFront: $backingDishFront;
}
interface $backingDishBack extends $$sprite {
}
interface $backingDishContent extends $$sprite {
}
interface $backingDishFront extends $$sprite {
}
interface $ingredientWaterJug extends $$container {
	readonly sprite: $ingredientWaterJugSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $ingredientWaterJugSprite extends $$sprite {
}
interface $ingredientSugarBowl extends $$container {
	readonly sprite: $ingredientSugarBowlSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $ingredientSugarBowlSprite extends $$sprite {
}
interface $ingredientCornStarch extends $$container {
	readonly sprite: $ingredientCornStarchSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $ingredientCornStarchSprite extends $$sprite {
}
interface $colorBottlePurple extends $$container {
	readonly sprite: $colorBottlePurpleSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $colorBottlePurpleSprite extends $$sprite {
}
interface $colorBottleGreen extends $$container {
	readonly sprite: $colorBottleGreenSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $colorBottleGreenSprite extends $$sprite {
}
interface $colorBottlePink extends $$container {
	readonly sprite: $colorBottlePinkSprite;
	readonly pouringPoint: $pouringPoint;
}
interface $colorBottlePinkSprite extends $$sprite {
}
interface $delightStep2 extends $$container {
	readonly bowlMix: $bakingDishMix;
	readonly spoon: $spoon;
	readonly spoonTop: $spoon;
}
interface $delightStep3 extends $$container {
	readonly bowlCook: $bakingDishCooked;
	readonly bowlMix: $bakingDishMix;
}
interface $bakingDishCooked extends $$container {
	readonly bowlBack: $backingDishBack;
	readonly bowlContent: $turkishDelightCooked;
	readonly bowlFront: $backingDishFront;
}
interface $turkishDelightCooked extends $$sprite {
}
interface $delightStep4 extends $$container {
	readonly bowlCook: $bakingDishCooked;
	readonly jelly: $backedDelight;
	readonly pieces: $delightPieces;
}
interface $backedDelight extends $$container {
	readonly pieces: $$array<$turkishDelightPiece>;
	readonly sprite: $turkishDelightCooked;
	readonly piecesMask: $piecesMask;
}
interface $piecesMask extends $$polygon {
}
interface $turkishDelightPiece extends $$container {
	readonly sprite: $delightPieceSprite;
	readonly topping: $turkishDelightPiecePowder;
}
interface $delightPieceSprite extends $$sprite {
}
interface $turkishDelightPiecePowder extends $$sprite {
}
interface $delightPieces extends $$container {
	readonly pieces: $$array<$turkishDelightPiece>;
}
interface $delightStep5 extends $$container {
	readonly sugar: $sugarTable;
	readonly sugarBag: $sugarBag;
	readonly sugarDrag: $sugarDrag;
	readonly pieces: $delightPiecesOrdered;
}
interface $sugarTable extends $$sprite {
}
interface $sugarBag extends $$sprite {
}
interface $sugarDrag extends $$sprite {
}
interface $delightPiecesOrdered extends $$container {
	readonly pieces: $$array<$turkishDelightPiece>;
}
interface $delightStep6 extends $$container {
	readonly box: $turkishDelightBox;
	readonly pieces: $delightPiecesOrdered;
	readonly arrow: $arrow;
	readonly arrowEnd: $arrow;
}
interface $turkishDelightBox extends $$container {
	readonly pieces: $$array<$turkishDelightPiece>;
	readonly sprite: $turkishDelightBoxSprite;
	readonly piecesMask: $boxPiecesMask;
}
interface $turkishDelightBoxSprite extends $$sprite {
}
interface $boxPiecesMask extends $$polygon {
}
interface $delightStep7 extends $$container {
	readonly box: $turkishDelightBox;
}
interface $coconutStep1 extends $$container {
	readonly cuttingBoard: $cuttingBoard;
	readonly coconutCut: $coconutCut;
}
interface $coconutCut extends $$container {
	readonly bottom: $$array<$coconutBottom>;
	readonly top: $$array<$coconutTop>;
	readonly sprite: $coconutWhole;
}
interface $coconutWhole extends $$sprite {
}
interface $coconutBottom extends $$sprite {
}
interface $coconutTop extends $$sprite {
}
interface $coconutStep2 extends $$container {
	readonly coconutHalf: $coconutHalf;
	readonly glass: $glass;
}
interface $coconutHalf extends $$container {
	readonly sprite: $coconutBottom;
	readonly empty: $coconutEmpty;
	readonly pouringPoint: $pouringPoint;
}
interface $coconutEmpty extends $$sprite {
}
interface $glass extends $$container {
	readonly glassBack: $glassBack;
	readonly drinkBack: $drinkBack;
	readonly straw: $straw1;
	readonly strawBottom: $straw1;
	readonly drinkFront: $drinkFront;
	readonly drinkMask: $drinkMask;
	readonly glassFront: $glassFront;
}
interface $glassBack extends $$sprite {
}
interface $drinkBack extends $$sprite {
}
interface $straw1 extends $$sprite {
}
interface $drinkFront extends $$sprite {
}
interface $drinkMask extends $$polygon {
}
interface $glassFront extends $$sprite {
}
interface $coconutStep3 extends $$container {
	readonly coconutHalf: $coconutHalf;
	readonly glass: $glass;
	readonly bowl: $coconutBowl;
	readonly coconutMeat: $coconutMeat1;
}
interface $coconutBowl extends $$container {
	readonly coconutMeat: $$array<$coconutMeat1|$coconutMeat2|$coconutMeat3>;
	readonly bowlBack: $coconutBowlBack;
	readonly bowlFront: $coconutBowlFront;
}
interface $coconutBowlBack extends $$sprite {
}
interface $coconutMeat1 extends $$sprite {
}
interface $coconutMeat2 extends $$sprite {
}
interface $coconutMeat3 extends $$sprite {
}
interface $coconutBowlFront extends $$sprite {
}
interface $coconutStep4 extends $$container {
	readonly coconutHalf: $coconutHalf;
	readonly fiber: $coconutFibers;
	readonly glass: $glass;
	readonly bowl: $coconutBowl;
}
interface $coconutFibers extends $$sprite {
}
interface $coconutStep5 extends $$container {
	readonly straw: $$array<$straw1|$straw2|$straw3|$straw4>;
	readonly glass: $glass;
	readonly bowl: $coconutBowl;
	readonly strawTop: $straw1;
	readonly fiber: $coconutFibers;
	readonly rope: $coconutFiberRope;
}
interface $straw4 extends $$sprite {
}
interface $straw3 extends $$sprite {
}
interface $straw2 extends $$sprite {
}
interface $coconutFiberRope extends $$sprite {
}
